const isVisibleNowFunction = (task) => {
    if (task.visible_on === "Always Visible") return true;
    if (new Date(task.visible_on).getTime() < new Date().getTime()) return true
    return false
}

export default isVisibleNowFunction; 